import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const rapidboardUserReportsOverviewRoute: InvariantJiraRoute = {
	name: 'rapidboard-user-reports-overview',
	path: '/jira/people/:accountId/boards/:boardId/reports',
};
